import { uniqueString } from '../util';
export const XmlContentTypeHeader = {
    'Content-Type': 'text/xml',
};
const defaultOptions = {
    body: uniqueString(),
    cookieKey: uniqueString(),
    from: uniqueString(),
};
export function getMockTwilioWebhookRequest({ body = defaultOptions.body, cookieKey = defaultOptions.cookieKey, from = defaultOptions.from, } = defaultOptions) {
    return {
        cookies: { [cookieKey]: {} },
        body: {
            Body: body,
            From: from,
        },
    };
}
